// @ts-nocheck

import React, { useState, useEffect } from "react";
import {
  ChevronRight,
  ChevronLeft,
  CheckCircle,
  BookOpen,
  Briefcase,
  User,
  Star,
  Send,
  MapPin,
  Smile,
  Meh,
  Frown,
  AlertCircle,
  Clock,
  Calendar,
  GraduationCap,
  Beaker,
  ThumbsUp,
  ThumbsDown,
  BellRing,
  Lightbulb,
  Linkedin,
  Copy,
  Check,
  Instagram,
  Facebook,
  MessageCircle,
  Award,
  Loader2,
  Share2,
  Camera,
} from "lucide-react";

// CONFIGURAÇÃO GOOGLE SHEETS
const GOOGLE_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbyAR4-TIkvE5BrbVrPQ_fTOROxHl1qfo_Hvht36CznJFGHPiY4ZTPseaU-JmyVLzyhH/exec";
const FORM_LINK = "https://portal-egresso-ifmg.vercel.app/";

// FIREBASE REMOVIDO PARA EVITAR ERROS DE API KEY NO SANDBOX
// A base de dados será salva apenas no Google Sheets conforme solicitado.

// ==========================================
// BASE DE DADOS DOS CURSOS IFMG
// ==========================================

const COURSE_DATABASE = [
  // Arcos
  { campus: "Arcos", course: "Engenharia Mecânica", modality: "Bacharelado", format: "Presencial" },
  { campus: "Arcos", course: "Direito", modality: "Bacharelado", format: "Presencial" },
  { campus: "Arcos", course: "Segurança do Trabalho", modality: "Especialização", format: "EaD" },
  { campus: "Arcos", course: "Engenharia de Segurança do Trabalho", modality: "Especialização", format: "EaD" },
  { campus: "Arcos", course: "Docência", modality: "Especialização", format: "EaD" },
  { campus: "Arcos", course: "Docência com Ênfase na Educação Básica, Inclusiva ou Profissional", modality: "Especialização", format: "EaD" },
  { campus: "Arcos", course: "Docência com Ênfase na Educação Básica", modality: "Especialização", format: "EaD" },
  { campus: "Arcos", course: "Docência com Ênfase na Educação Inclusiva", modality: "Especialização", format: "EaD" },
  { campus: "Arcos", course: "Educação para Docência Profissional e Tecnológica", modality: "Especialização", format: "EaD" },
  { campus: "Arcos", course: "Partiu IF", modality: "FIC", format: "Presencial" },
  { campus: "Arcos", course: "Automação Industrial", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Arcos", course: "Eletromecânica", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Arcos", course: "Eletrotécnica", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Arcos", course: "Informática", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Arcos", course: "Mecânica", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Arcos", course: "Redes de Computadores", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Arcos", course: "Administração", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Arcos", course: "Mecânica", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Arcos", course: "Mecânica", modality: "Técnico Subsequente", format: "Presencial" },

  // Bambuí
  { campus: "Bambuí", course: "Engenharia de Alimentos", modality: "Bacharelado", format: "Presencial" },
  { campus: "Bambuí", course: "Medicina Veterinária", modality: "Bacharelado", format: "Presencial" },
  { campus: "Bambuí", course: "Administração", modality: "Bacharelado", format: "Presencial" },
  { campus: "Bambuí", course: "Agronomia", modality: "Bacharelado", format: "Presencial" },
  { campus: "Bambuí", course: "Engenharia de Produção", modality: "Bacharelado", format: "Presencial" },
  { campus: "Bambuí", course: "Engenharia de Computação", modality: "Bacharelado", format: "Presencial" },
  { campus: "Bambuí", course: "Zootecnia", modality: "Bacharelado", format: "Presencial" },
  { campus: "Bambuí", course: "Educação para Relações Étnico-Raciais", modality: "Especialização", format: "EaD" },
  { campus: "Bambuí", course: "Ensino de Ciências e Matemática", modality: "Especialização", format: "Presencial" },
  { campus: "Bambuí", course: "Controle Ambiental na Indústria de Alimentos", modality: "Especialização", format: "Presencial" },
  { campus: "Bambuí", course: "Educação Ambiental", modality: "Especialização", format: "Presencial" },
  { campus: "Bambuí", course: "Educação Profissional Integrada à Educação Básica na Modalidade de Educação de Jovens e Adultos - PROEJA", modality: "Especialização", format: "Presencial" },
  { campus: "Bambuí", course: "Finanças Empresariais", modality: "Especialização", format: "Presencial" },
  { campus: "Bambuí", course: "Gestão - Ênfase em Tecnologia e Inovação", modality: "Especialização", format: "EaD" },
  { campus: "Bambuí", course: "Gestão - Ênfase em Estratégia e Marketing", modality: "Especialização", format: "EaD" },
  { campus: "Bambuí", course: "Gestão - Ênfase em Marketing Digital", modality: "Especialização", format: "EaD" },
  { campus: "Bambuí", course: "Ciências Biológicas", modality: "Licenciatura", format: "Presencial" },
  { campus: "Bambuí", course: "Física", modality: "Licenciatura", format: "Presencial" },
  { campus: "Bambuí", course: "Educação Física", modality: "Licenciatura", format: "Presencial" },
  { campus: "Bambuí", course: "Sustentabilidade e Tecnologia Ambiental", modality: "Mestrado", format: "Presencial" },
  { campus: "Bambuí", course: "Manutenção Automotiva", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Bambuí", course: "Biotecnologia", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Bambuí", course: "Mecânica Agrícola", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Bambuí", course: "Mecânica Automotiva", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Bambuí", course: "Mecânica Agrícola e Automotiva", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Bambuí", course: "Agroindústria", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Bambuí", course: "Agropecuária", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Bambuí", course: "Administração", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Bambuí", course: "Eletromecânica", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Bambuí", course: "Meio Ambiente", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Bambuí", course: "Informática", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Bambuí", course: "Açúcar e Álcool", modality: "Técnico PROEJA", format: "Presencial" },
  { campus: "Bambuí", course: "Comércio", modality: "Técnico PROEJA", format: "Presencial" },
  { campus: "Bambuí", course: "Gestão Comercial", modality: "Técnico PROEJA", format: "Presencial" },
  { campus: "Bambuí", course: "Mecânica Agrícola", modality: "Técnico PROEJA", format: "Presencial" },
  { campus: "Bambuí", course: "Mecânica Automotiva", modality: "Técnico PROEJA", format: "Presencial" },
  { campus: "Bambuí", course: "Mecânica e Manutenção de Motocicletas", modality: "Técnico PROEJA", format: "Presencial" },
  { campus: "Bambuí", course: "Agrícola com Habilitação em Agricultura", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Bambuí", course: "Agrícola com Habilitação em Zootecnia", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Bambuí", course: "Agricultura", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Bambuí", course: "Zootecnia", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Bambuí", course: "Agropecuária", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Manutenção Automotiva", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Rede de computadores", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Bambuí", course: "Açúcar e Álcool", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Agrícola com Habilitação em Agricultura", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Agrícola com Habilitação em Zootecnia", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Agricultura", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Comércio", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Ecoturismo", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Eventos", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Gerência em Saúde", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Gestão Comercial", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Gestão em Serviços de Saúde", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Informática", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Informática - Programação Comercial", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Informática - Programação para Internet", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Informática - Programação Web", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Informática - Redes e Manutenção", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Manutenção e Suporte em Informática", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Mecânica Agrícola", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Mecânica Automotiva", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Meio Ambiente", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Turismo", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Zootecnia", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Bambuí", course: "Análise e Desenvolvimento de Sistemas", modality: "Tecnologia", format: "Presencial" },
  { campus: "Bambuí", course: "Informática no Agronegócio", modality: "Tecnologia", format: "Presencial" },
  { campus: "Bambuí", course: "Administração - Gestão de Pequenas e Médias Empresas", modality: "Tecnologia", format: "Presencial" },
  { campus: "Bambuí", course: "Alimentos", modality: "Tecnologia", format: "Presencial" },
  { campus: "Bambuí", course: "Gestão de Turismo", modality: "Tecnologia", format: "Presencial" },
  { campus: "Bambuí", course: "Processamento de Alimentos", modality: "Tecnologia", format: "Presencial" },
  { campus: "Bambuí", course: "Sistemas para Internet", modality: "Tecnologia", format: "Presencial" },

  // Betim
  { campus: "Betim", course: "Engenharia de Controle e Automação", modality: "Bacharelado", format: "Presencial" },
  { campus: "Betim", course: "Engenharia Mecânica", modality: "Bacharelado", format: "Presencial" },
  { campus: "Betim", course: "Mecânica", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Betim", course: "Química", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Betim", course: "Automação Industrial", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Betim", course: "Mecânica", modality: "Técnico Subsequente", format: "Presencial" },

  // Congonhas
  { campus: "Congonhas", course: "Engenharia de Produção", modality: "Bacharelado", format: "Presencial" },
  { campus: "Congonhas", course: "Engenharia Mecânica", modality: "Bacharelado", format: "Presencial" },
  { campus: "Congonhas", course: "Gestão de Projetos e Operações", modality: "Especialização", format: "Presencial" },
  { campus: "Congonhas", course: "Física", modality: "Licenciatura", format: "Presencial" },
  { campus: "Congonhas", course: "Letras", modality: "Licenciatura", format: "Presencial" },
  { campus: "Congonhas", course: "Mineração", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Congonhas", course: "Edificações", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Congonhas", course: "Manutenção e Suporte em Informática", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Congonhas", course: "Edificações", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Congonhas", course: "Mecânica", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Congonhas", course: "Mineração", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Congonhas", course: "Produção Industrial", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Congonhas", course: "Mineração", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Congonhas", course: "Mecânica", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Congonhas", course: "Edificações", modality: "Técnico Subsequente", format: "Presencial" },

  // Conselheiro Lafaiete
  { campus: "Conselheiro Lafaiete", course: "Mecânica", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Conselheiro Lafaiete", course: "Eletrotécnica", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Conselheiro Lafaiete", course: "Mecânica", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Conselheiro Lafaiete", course: "Eletrotécnica", modality: "Técnico Subsequente", format: "Presencial" },

  // Formiga
  { campus: "Formiga", course: "Engenharia Elétrica", modality: "Bacharelado", format: "Presencial" },
  { campus: "Formiga", course: "Ciência da Computação", modality: "Bacharelado", format: "Presencial" },
  { campus: "Formiga", course: "Administração", modality: "Bacharelado", format: "Presencial" },
  { campus: "Formiga", course: "Análise Estratégica de Dados", modality: "Especialização", format: "EaD" },
  { campus: "Formiga", course: "Matemática", modality: "Licenciatura", format: "Presencial" },
  { campus: "Formiga", course: "Administração", modality: "Mestrado", format: "Presencial" },
  { campus: "Formiga", course: "Eletrotécnica", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Formiga", course: "Administração", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Formiga", course: "Informática", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Formiga", course: "Gestão Financeira", modality: "Tecnologia", format: "Presencial" },

  // Governador Valadares
  { campus: "Governador Valadares", course: "Engenharia Civil", modality: "Bacharelado", format: "Presencial" },
  { campus: "Governador Valadares", course: "Engenharia Ambiental e Sanitária", modality: "Bacharelado", format: "Presencial" },
  { campus: "Governador Valadares", course: "Engenharia de Produção", modality: "Bacharelado", format: "Presencial" },
  { campus: "Governador Valadares", course: "Engenharia de Segurança do Trabalho", modality: "Especialização", format: "Presencial" },
  { campus: "Governador Valadares", course: "Meio Ambiente", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Governador Valadares", course: "Edificações", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Governador Valadares", course: "Segurança do Trabalho", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Governador Valadares", course: "Administração", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Governador Valadares", course: "Serviços Jurídicos", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Governador Valadares", course: "Logística", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Governador Valadares", course: "Segurança do Trabalho", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Governador Valadares", course: "Gestão Ambiental", modality: "Tecnologia", format: "Presencial" },
  
  // Ibirité
  { campus: "Ibirité", course: "Ciência da Computação", modality: "Bacharelado", format: "Presencial" },
  { campus: "Ibirité", course: "Engenharia de Controle e Automação", modality: "Bacharelado", format: "Presencial" },
  { campus: "Ibirité", course: "Eletrotécnica", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Ibirité", course: "Mecatrônica", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Ibirité", course: "Sistemas de Energia Renovável", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Ibirité", course: "Automação Industrial", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Ibirité", course: "Sistemas de Energia Renovável", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ibirité", course: "Automação Industrial", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ibirité", course: "Informática", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ibirité", course: "Mecatrônica", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ibirité", course: "Automação Industrial", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ibirité", course: "Eletrotécnica", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ibirité", course: "Mecatrônica", modality: "Técnico Subsequente", format: "Presencial" },

  // Ipatinga
  { campus: "Ipatinga", course: "Engenharia Elétrica", modality: "Bacharelado", format: "Presencial" },
  { campus: "Ipatinga", course: "Docência com Ênfase na Educação Inclusiva", modality: "Especialização", format: "Presencial" },
  { campus: "Ipatinga", course: "Docência com Ênfase na Educação Inclusiva", modality: "Especialização", format: "EaD" },
  { campus: "Ipatinga", course: "Automação Industrial", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ipatinga", course: "Eletrotécnica", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ipatinga", course: "Mecânica", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ipatinga", course: "Eletrotécnica", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ipatinga", course: "Segurança do Trabalho", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ipatinga", course: "Eletrotécnica", modality: "Técnico Subsequente", format: "EaD" },

  // Itabirito
  { campus: "Itabirito", course: "Engenharia Elétrica", modality: "Bacharelado", format: "Presencial" },
  { campus: "Itabirito", course: "Automação Industrial", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Itabirito", course: "Informática Industrial", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Itabirito", course: "Informática Industrial", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Itabirito", course: "Informática Industrial", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Itabirito", course: "Mecânica", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Itabirito", course: "Mecânica", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Itabirito", course: "Mecânica", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Itabirito", course: "Mineração", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Itabirito", course: "Mineração", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Itabirito", course: "Mecânica", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Itabirito", course: "Eletroeletrônica", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Itabirito", course: "Eletroeletrônica", modality: "Técnico Concomitante", format: "Presencial" },

  // Ouro Branco
  { campus: "Ouro Branco", course: "Administração", modality: "Bacharelado", format: "Presencial" },
  { campus: "Ouro Branco", course: "Sistemas de Informação", modality: "Bacharelado", format: "Presencial" },
  { campus: "Ouro Branco", course: "Engenharia Metalúrgica", modality: "Bacharelado", format: "Presencial" },
  { campus: "Ouro Branco", course: "Práticas Avaliativas", modality: "Especialização", format: "EaD" },
  { campus: "Ouro Branco", course: "Gestão de Negócios", modality: "Especialização", format: "Presencial" },
  { campus: "Ouro Branco", course: "Computação", modality: "Licenciatura", format: "Presencial" },
  { campus: "Ouro Branco", course: "Pedagogia", modality: "Licenciatura", format: "Presencial" },
  { campus: "Ouro Branco", course: "Educação Profissional e Tecnológica", modality: "Mestrado", format: "Presencial" },
  { campus: "Ouro Branco", course: "Administração", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ouro Branco", course: "Metalurgia", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ouro Branco", course: "Informática", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ouro Branco", course: "Soldagem", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Ouro Branco", course: "Administração", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Ouro Branco", course: "Administração", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Branco", course: "Metalurgia", modality: "Técnico Subsequente", format: "Presencial" },

  // Ouro Preto
  { campus: "Ouro Preto", course: "Inteligência Artificial", modality: "Especialização", format: "Presencial" },
  { campus: "Ouro Preto", course: "Gestão e Conservação do Patrimônio Cultural", modality: "Especialização", format: "Presencial" },
  { campus: "Ouro Preto", course: "Educação com Ênfase na Educação Inclusiva", modality: "Especialização", format: "EaD" },
  { campus: "Ouro Preto", course: "Ensino de Língua Portuguesa na Educação Básica", modality: "Especialização", format: "Presencial" },
  { campus: "Ouro Preto", course: "Educação Matemática", modality: "Especialização", format: "Presencial" },
  { campus: "Ouro Preto", course: "Geografia", modality: "Licenciatura", format: "Presencial" },
  { campus: "Ouro Preto", course: "Física", modality: "Licenciatura", format: "Presencial" },
  { campus: "Ouro Preto", course: "Ensino de Geografia em Rede - PROFGEO", modality: "Mestrado", format: "Presencial" },
  { campus: "Ouro Preto", course: "Administração", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ouro Preto", course: "Metalurgia", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ouro Preto", course: "Automação Industrial", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ouro Preto", course: "Mineração", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ouro Preto", course: "Edificações", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ouro Preto", course: "Informática Industrial", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ouro Preto", course: "Magistério em Educação Física", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ouro Preto", course: "Instrumentação Eletrônica e Controle de Processos", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ouro Preto", course: "Manutenção e Suporte em Informática", modality: "Técnico Integrado EJA", format: "Presencial" },
  { campus: "Ouro Preto", course: "Joalheria Proeja", modality: "Técnico Integrado EJA", format: "Presencial" },
  { campus: "Ouro Preto", course: "Edificações", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Mineração", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Automação Industrial", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Segurança do Trabalho", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Joalheria", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Metalurgia", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Meio Ambiente", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Turismo", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Gemologia", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Metalografia", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Ourivessaria", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Instrumentação Manual e Ourivessaria", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Guia de Turismo Regional", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Processamento de Dados", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Gerenciamento de Serviços Alimentares", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Manutenção e Suporte em Informática", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Mecanografia", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ouro Preto", course: "Eletroletrônica", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Ouro Preto", course: "Controle Ambiental", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Ouro Preto", course: "Edificações", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Ouro Preto", course: "Hospedagem", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Ouro Preto", course: "Meio Ambiente", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Ouro Preto", course: "Serviços Públicos", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Ouro Preto", course: "Metalurgia", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Ouro Preto", course: "Mineração", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Ouro Preto", course: "Análise e Desenvolvimento de Sistemas", modality: "Tecnologia", format: "Presencial" },
  { campus: "Ouro Preto", course: "Conservação e Restauro", modality: "Tecnologia", format: "Presencial" },
  { campus: "Ouro Preto", course: "Gastronomia", modality: "Tecnologia", format: "Presencial" },
  { campus: "Ouro Preto", course: "Gestão da Qualidade", modality: "Tecnologia", format: "Presencial" },

  // Piumhi
  { campus: "Piumhi", course: "Edificações", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Piumhi", course: "Engenharia Civil", modality: "Bacharelado", format: "Presencial" },
  { campus: "Piumhi", course: "Educação Básica: Teoria e Prática", modality: "Especialização", format: "EaD" },
  { campus: "Piumhi", course: "BIM: Projetos Aplicados às Edificações", modality: "Especialização", format: "EaD" },
  { campus: "Piumhi", course: "Edificações", modality: "Técnico Integrado", format: "Presencial" },

  // Ponte Nova
  { campus: "Ponte Nova", course: "Docência com Ênfase na Educação Básica, Inclusiva ou Profissional", modality: "Especialização", format: "EaD" },
  { campus: "Ponte Nova", course: "Informática", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ponte Nova", course: "Administração", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ponte Nova", course: "Administração", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ponte Nova", course: "Informática", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ponte Nova", course: "Processos Gerenciais", modality: "Tecnologia", format: "Presencial" },

  // Ribeirão das Neves
  { campus: "Ribeirão das Neves", course: "Administração", modality: "Bacharelado", format: "Presencial" },
  { campus: "Ribeirão das Neves", course: "Educação", modality: "Especialização", format: "EaD" },
  { campus: "Ribeirão das Neves", course: "Gestão Pública e Desenvolvimento Regional", modality: "Especialização", format: "Presencial" },
  { campus: "Ribeirão das Neves", course: "EaD na Educação Profissional e Tecnológica", modality: "Especialização", format: "EaD" },
  { campus: "Ribeirão das Neves", course: "Montador de andaimes", modality: "FIC", format: "Presencial" },
  { campus: "Ribeirão das Neves", course: "Técnico em Informática", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Ribeirão das Neves", course: "Administração", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ribeirão das Neves", course: "Eletroeletrônica", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ribeirão das Neves", course: "Informática", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Ribeirão das Neves", course: "Administração", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Ribeirão das Neves", course: "Logística", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Ribeirão das Neves", course: "Logística", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Ribeirão das Neves", course: "Logística", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Ribeirão das Neves", course: "Análise e Desenvolvimento de Sistemas", modality: "Tecnologia", format: "Presencial" },
  { campus: "Ribeirão das Neves", course: "Processos Gerenciais", modality: "Tecnologia", format: "Presencial" },

  // Sabará
  { campus: "Sabará", course: "Engenharia de Controle e Automação", modality: "Bacharelado", format: "Presencial" },
  { campus: "Sabará", course: "Sistemas de Informação", modality: "Bacharelado", format: "Presencial" },
  { campus: "Sabará", course: "Administração", modality: "Bacharelado", format: "Presencial" },
  { campus: "Sabará", course: "Ensino de Língua Portuguesa e Literatura na Educação Básica", modality: "Especialização", format: "EaD" },
  { campus: "Sabará", course: "Gestão na Educação Profissional e Tecnológica", modality: "Especialização", format: "EaD" },
  { campus: "Sabará", course: "Educação Matemática", modality: "Especialização", format: "Presencial" },
  { campus: "Sabará", course: "Logística", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Sabará", course: "Informática", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Sabará", course: "Administração", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Sabará", course: "Eletrônica", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Sabará", course: "Administração", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Sabará", course: "Edificações", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Sabará", course: "Processos Gerenciais", modality: "Tecnologia", format: "Presencial" },
  { campus: "Sabará", course: "Logística", modality: "Tecnologia", format: "Presencial" }, 

  // Santa Luzia
  { campus: "Santa Luzia", course: "Arquitetura e Urbanismo", modality: "Bacharelado", format: "Presencial" },
  { campus: "Santa Luzia", course: "Engenharia Civil", modality: "Bacharelado", format: "Presencial" },
  { campus: "Santa Luzia", course: "Proteção e Defesa Civil", modality: "Especialização", format: "EaD" },
  { campus: "Santa Luzia", course: "Autonomia e Renda - Auxiliar de Serviços Diversos", modality: "FIC", format: "Presencial" },
  { campus: "Santa Luzia", course: "Segurança do Trabalho Trilhas C", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Santa Luzia", course: "Paisagismo Trilhas C", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "Santa Luzia", course: "Edificações", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Santa Luzia", course: "Segurança do Trabalho", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "Santa Luzia", course: "Paisagismo Trilhas", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Santa Luzia", course: "Paisagismo", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Santa Luzia", course: "Desenho para construção civil", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Santa Luzia", course: "Segurança do Trabalho", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Santa Luzia", course: "Automação Industrial", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Santa Luzia", course: "Informática para Internet", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "Santa Luzia", course: "Segurança do Trabalho Trilhas", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "Santa Luzia", course: "Design de Interiores", modality: "Tecnologia", format: "Presencial" },

  // São João Evangelista
  { campus: "São João Evangelista", course: "Administração", modality: "Bacharelado", format: "Presencial" },
  { campus: "São João Evangelista", course: "Engenharia Florestal", modality: "Bacharelado", format: "Presencial" },
  { campus: "São João Evangelista", course: "Sistemas de Informação", modality: "Bacharelado", format: "Presencial" },
  { campus: "São João Evangelista", course: "Agronomia", modality: "Bacharelado", format: "Presencial" },
  { campus: "São João Evangelista", course: "Agrimensura", modality: "Especialização", format: "EaD" },
  { campus: "São João Evangelista", course: "Educação Matemática e suas Tecnologias", modality: "Especialização", format: "EaD" },
  { campus: "São João Evangelista", course: "Ensino e Tecnologias Educacionais", modality: "Especialização", format: "EaD" },
  { campus: "São João Evangelista", course: "Pecuária Leiteira com Ênfase em Tecnologias Sociais", modality: "Especialização", format: "Presencial" },
  { campus: "São João Evangelista", course: "Meio Ambiente", modality: "Especialização", format: "Presencial" },
  { campus: "São João Evangelista", course: "Meio Ambiente", modality: "Especialização", format: "EaD" },
  { campus: "São João Evangelista", course: "Ciências Biológicas", modality: "Licenciatura", format: "Presencial" },
  { campus: "São João Evangelista", course: "Gestão", modality: "Especialização", format: "EaD" },
  { campus: "São João Evangelista", course: "Matemática", modality: "Licenciatura", format: "Presencial" },
  { campus: "São João Evangelista", course: "Pedagogia", modality: "Licenciatura", format: "Presencial" },
  { campus: "São João Evangelista", course: "Nutrição e Dietética", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "São João Evangelista", course: "Agrimensura", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "São João Evangelista", course: "Agropecuária", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "São João Evangelista", course: "Informática", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "São João Evangelista", course: "Alimentação", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "São João Evangelista", course: "Economia Doméstica", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "São João Evangelista", course: "Agropecuária", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "São João Evangelista", course: "Alimentação", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "São João Evangelista", course: "Informática", modality: "Técnico Concomitante", format: "Presencial" },
  { campus: "São João Evangelista", course: "Ginasial Agrícola", modality: "Integrado ao 1º grau", format: "Presencial" },
  { campus: "São João Evangelista", course: "Manutenção e Suporte em Informática", modality: "Técnico Integrado", format: "Presencial" },
  { campus: "São João Evangelista", course: "Florestas", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "São João Evangelista", course: "Artesanato", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "São João Evangelista", course: "Reciclagem", modality: "Técnico Subsequente", format: "EaD" },
  { campus: "São João Evangelista", course: "Agrimensura", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "São João Evangelista", course: "Informática", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "São João Evangelista", course: "Meio Ambiente", modality: "Técnico Subsequente", format: "Presencial" },
  { campus: "São João Evangelista", course: "Silvicultura", modality: "Tecnologia", format: "Presencial" }
];

const MODALITY_LABELS = {
  "Técnico Integrado": "Técnico Integrado (Ensino Médio + Técnico)",
  "Técnico Integrado ao Ensino Médio":
    "Técnico Integrado (Ensino Médio + Técnico)",
  "Técnico Subsequente": "Técnico Subsequente (Pós-Médio)",
  "Técnico Concomitante":
    "Técnico Concomitante (Cursa o Ensino Médio em outra escola)",
  "Técnico Integrado EJA": "Técnico Integrado EJA (Jovens e Adultos)",
  Bacharelado: "Graduação (Bacharelado)",
  Licenciatura: "Graduação (Licenciatura)",
  Tecnologia: "Graduação (Tecnólogo)",
  Especialização: "Pós-Graduação (Especialização ≥ 360h)",
  Mestrado: "Mestrado",
  FIC: "Qualificação (Carga horária menor que 360 horas)",
  Qualificação: "Qualificação (Carga horária menor que 360 horas)",
};

const UNIQUE_CAMPUSES = [
  ...new Set(COURSE_DATABASE.map((item) => item.campus)),
].sort();

const GENDER_OPTIONS = [
  {
    id: "Mulher Cis",
    desc: "Identifica-se como mulher e foi registrada com esse gênero ao nascer.",
  },
  {
    id: "Homem Cis",
    desc: "Identifica-se como homem e foi registrado com esse gênero ao nascer.",
  },
  {
    id: "Mulher Trans",
    desc: "Identifica-se como mulher, mas foi registrada com outro gênero ao nascer.",
  },
  {
    id: "Homem Trans",
    desc: "Identifica-se como homem, mas foi registrado com outro gênero ao nascer.",
  },
  {
    id: "Não binário",
    desc: "Não se identifica exclusivamente como homem ou como mulher.",
  },
  { id: "Prefiro não informar", desc: "" },
];

const PCD_TYPES = [
  "Deficiência Auditiva",
  "Deficiência Física",
  "Deficiência Intelectual",
  "Deficiência Psicossocial (transtorno mental)",
  "Deficiência Visual",
  "Transtorno do Espectro Autista (TEA)",
  "Prefiro não informar",
];

const RACES = [
  "Amarela",
  "Branca",
  "Indígena",
  "Parda",
  "Preta",
  "Prefiro não informar",
];
const MONTHS = [
  "Jan",
  "Fev",
  "Mar",
  "Abr",
  "Mai",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Out",
  "Nov",
  "Dez",
];

const PRACTICE_TYPES = [
  "Estágio",
  "TCC / Projeto Final",
  "Monitoria",
  "Iniciação Científica",
  "Projeto de Extensão",
  "Projeto de Ensino",
  "Jovem Aprendiz",
  "Atividades Culturais",
];

const SKILLS_LIST = [
  "Conhecimento Técnico",
  "Inteligência Artificial (IA)",
  "Prática em Laboratório",
  "Gestão e Liderança",
  "Análise de Dados",
  "Comunicação / Oratória",
  "Empreendedorismo",
  "Sustentabilidade",
  "Trabalho em Equipe",
  "Inglês / Idiomas",
  "Resolução de Problemas",
  "Ética Profissional",
];

const LAB_SUFFICIENCY_OPTIONS = [
  { label: "Sim, em todas as aulas", icon: ThumbsUp, color: "text-green-600" },
  { label: "Na maioria das aulas", icon: ThumbsUp, color: "text-green-500" },
  { label: "Em cerca da metade", icon: Meh, color: "text-yellow-500" },
  { label: "Em poucas aulas", icon: ThumbsDown, color: "text-orange-500" },
  {
    label: "Equipamentos insuficientes",
    icon: AlertCircle,
    color: "text-red-500",
  },
  { label: "Não se aplica", icon: BookOpen, color: "text-gray-400" },
];

const JOB_TYPES = [
  "CLT (Carteira Assinada)",
  "Servidor Público (Estatutário)",
  "PJ / Autônomo",
  "Empresário / Sócio",
  "Microempreendedor (MEI)",
  "Estagiário",
  "Temporário",
  "Outro",
];

const STUDY_TYPES = [
  "Curso Técnico",
  "Graduação",
  "Pós-Graduação - Qualificação (< 360h)",
  "Pós-Graduação - Especialização (≥ 360h)",
  "Mestrado",
  "Doutorado",
  "Curso de Curta Duração / Livre",
  "Outro",
];

// COMPONENTS
const BadgeLogoIFMG = () => (
  <img
    src="https://www.ifmg.edu.br/portal/centrais-de-conteudos/publicacoes/informativo/183/183_arquivos/logo-1.png/@@images/5076e06e-d465-431a-b2cd-0b728c0227e3.png"
    alt="Logo IFMG"
    className="h-14 md:h-16 w-auto"
  />
);

const MiniLogoIFMG = () => (
  <img
    src="https://www.ifmg.edu.br/portal/centrais-de-conteudos/publicacoes/informativo/183/183_arquivos/logo-1.png/@@images/5076e06e-d465-431a-b2cd-0b728c0227e3.png"
    alt="Logo IF"
    className="h-8 w-auto"
  />
);

const ProgressBar = ({ currentStep, totalSteps }) => {
  const progress = ((currentStep + 1) / totalSteps) * 100;
  return (
    <div className="w-full bg-gray-200 h-2 rounded-full mb-6 overflow-hidden">
      <div
        className="bg-green-600 h-2 transition-all duration-500 ease-out"
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  );
};

const ErrorMessage = ({ message }) => (
  <p className="text-red-600 text-sm mt-1 flex items-center gap-1 font-medium animate-pulse">
    <AlertCircle size={14} /> {message}
  </p>
);

const formatPhone = (value) => {
  if (!value) return "";
  const numbers = value.replace(/\D/g, "");
  if (numbers.length <= 2) return numbers.replace(/^(\d{0,2})/, "($1");
  if (numbers.length <= 7)
    return numbers.replace(/^(\d{2})(\d{0,5})/, "($1) $2");
  return numbers.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, "($1) $2-$3");
};

const RatingStars = ({ value, onChange, name, error }) => {
  return (
    <div>
      <div className="flex gap-2 justify-center sm:justify-start">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => onChange(name, star)}
            className={`p-1 sm:p-2 rounded-full transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-yellow-100 ${
              value >= star
                ? "text-yellow-400 scale-110"
                : "text-gray-300 hover:text-gray-400"
            }`}
          >
            <Star fill={value >= star ? "currentColor" : "none"} size={32} />
          </button>
        ))}
      </div>
      {error && <ErrorMessage message="Por favor, dê uma nota." />}
    </div>
  );
};

const CardOption = ({
  selected,
  onClick,
  icon: IconComponent,
  title,
  description,
  compact = false,
}) => (
  <div
    onClick={onClick}
    className={`cursor-pointer border-2 rounded-xl flex items-center gap-3 transition-all duration-200 relative overflow-hidden
      ${compact ? "p-3" : "p-4"}
      ${
        selected
          ? "border-green-600 bg-green-50 shadow-md transform scale-[1.02]"
          : "border-gray-200 hover:border-green-200 hover:bg-gray-50"
      }`}
  >
    {selected && (
      <div className="absolute top-0 right-0 w-16 h-16 bg-green-100 rounded-bl-full -mr-8 -mt-8 opacity-50 z-0"></div>
    )}
    {IconComponent && (
      <div
        className={`rounded-full flex-shrink-0 z-10 ${
          compact ? "p-2" : "p-3"
        } ${
          selected ? "bg-green-600 text-white" : "bg-gray-100 text-gray-500"
        }`}
      >
        <IconComponent size={compact ? 18 : 24} />
      </div>
    )}
    <div className="text-left flex-grow z-10">
      <h3
        className={`font-semibold ${compact ? "text-sm" : "text-base"} ${
          selected ? "text-green-800" : "text-gray-700"
        }`}
      >
        {title}
      </h3>
      {description && (
        <p className="text-xs text-gray-500 mt-1">{description}</p>
      )}
    </div>
    <div className="ml-auto flex-shrink-0 pl-2 z-10">
      <div
        className={`rounded-full border-2 flex items-center justify-center transition-colors ${
          compact ? "w-5 h-5" : "w-6 h-6"
        } ${selected ? "border-green-600 bg-white" : "border-gray-300"}`}
      >
        {selected && (
          <div
            className={`${
              compact ? "w-2.5 h-2.5" : "w-3 h-3"
            } rounded-full bg-green-600`}
          />
        )}
      </div>
    </div>
  </div>
);

// COMPONENTE DO NOVO SELO ATUALIZADO
const IfmgBadge = () => (
  <div className="mx-auto w-full max-w-sm overflow-hidden rounded-[2rem] border-4 border-white shadow-2xl bg-[#2B5C4D]">
    <img
      src="/Selo.jpg" // ⚠️ Lembre-se de colocar o arquivo Selo.jpg na pasta 'public' do seu projeto
      alt="Selo Minha História Começou Aqui - IFMG"
      className="block h-auto w-full object-contain"
    />
  </div>
);

// MAIN APP
export default function App() {
  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [copied, setCopied] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);

  useEffect(() => {
    if (!document.querySelector('meta[name="viewport"]')) {
      const meta = document.createElement("meta");
      meta.name = "viewport";
      meta.content =
        "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
      document.head.appendChild(meta);
    }
    if (!document.querySelector('script[src="https://cdn.tailwindcss.com"]')) {
      const script = document.createElement("script");
      script.src = "https://cdn.tailwindcss.com";
      document.head.appendChild(script);
    }
  }, []);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    isPcd: "",
    pcdType: [],
    gender: "",
    race: "",
    isQuilombola: "",
    campus: "",
    modality: "",
    course: "",
    customCourse: "",
    format: "",
    completionYear: "2025",
    practices: [],
    hasAnotherCourse: "",
    previousCourseModality: "", // Novo campo inserido
    infraRating: 0,
    teacherRating: 0,
    supportRating: 0,
    labsSufficiency: "",
    expectationMet: "",
    expectationReason: "",
    skillsUsed: [],
    skillsGap: [],
    workedDuringCourse: "",
    isStudying: "",
    currentStudyType: "",
    currentStudyRelation: "",
    isStudyingAtIFMG: "",
    studyInstitutionType: "",
    workingStatus: "",
    jobTitle: "",
    jobRelation: "",
    salaryRange: "",
    jobType: "",
    workModality: "",
    workSector: "",
    wantEvents: "",
    wantNews: "",
    eventType: "",
    availableMonths: [],
    suggestions: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setErrors({});
  }, [step]);

  const handleChange = (field, value) => {
    if (field === "phone") {
      value = formatPhone(value);
    }
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: null }));
  };

  const toggleSelection = (field, item) => {
    setFormData((prev) => {
      const current = prev[field] || [];
      if (current.includes(item)) {
        return { ...prev, [field]: current.filter((i) => i !== item) };
      } else {
        return { ...prev, [field]: [...current, item] };
      }
    });
  };

  const shareText = `Eu sou IFMG! 🎓 Acabei de participar da Pesquisa de Acompanhamento de Egressos e ajudei a construir o futuro do nosso curso. Não deixe nossa turma de fora, participe você também e represente sua geração: ${FORM_LINK}`;
  const encodedShareText = encodeURIComponent(shareText);
  const encodedFormLink = encodeURIComponent(FORM_LINK);

  const handleCopyLink = () => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(shareText);
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = shareText;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${encodedShareText}`, "_blank");
  };

  const handleFacebookShare = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodedFormLink}&quote=${encodedShareText}`,
      "_blank"
    );
  };

  const handleLinkedInShare = () => {
    handleCopyLink();
    setTimeout(() => {
      window.open(
        `https://www.linkedin.com/sharing/share-offsite/?url=${encodedFormLink}`,
        "_blank"
      );
    }, 500);
  };

  const handleInstagramShare = () => {
    handleCopyLink();
    setShowPrintModal(true);
  };

  const handleTikTokShare = () => {
    handleCopyLink();
    setTimeout(() => {
      window.open(`https://www.tiktok.com/`, "_blank");
    }, 500);
  };

  const validateStep = (currentStep) => {
    const newErrors = {};
    let isValid = true;

    if (currentStep === 1) {
      if (!formData.fullName.trim() || formData.fullName.split(" ").length < 2)
        newErrors.fullName = "Por favor, digite seu nome completo.";
      if (!formData.email.trim() || !formData.email.includes("@"))
        newErrors.email = "Precisamos de um e-mail válido.";
      if (!formData.phone.trim() || formData.phone.length < 14)
        newErrors.phone = "Digite um telefone válido.";
      if (!formData.gender)
        newErrors.gender = "Selecione como você se identifica.";
      if (!formData.race) newErrors.race = "Selecione sua cor/raça.";
      if (!formData.isQuilombola)
        newErrors.isQuilombola = "Selecione uma opção.";
      if (!formData.isPcd) newErrors.isPcd = "Selecione uma opção.";
      if (
        formData.isPcd === "Sim" &&
        (!formData.pcdType || formData.pcdType.length === 0)
      ) {
        newErrors.pcdType =
          "Selecione pelo menos um tipo de deficiência ou 'Prefiro não informar'.";
      }
    }

    if (currentStep === 2) {
      if (!formData.campus) newErrors.campus = "Selecione o campus.";
      if (!formData.modality) newErrors.modality = "Selecione o tipo de curso.";
      
      const isQualificacao = formData.modality && formData.modality.includes("Qualificação");
      
      if (isQualificacao) {
        if (!formData.customCourse.trim())
          newErrors.customCourse = "Por favor, digite o nome exato do seu curso.";
      } else {
        if (!formData.course) newErrors.course = "Selecione o curso.";
        if (formData.course === "Outro" && !formData.customCourse.trim())
          newErrors.customCourse = "Por favor, informe o nome do curso.";
      }
      
      if (!formData.format) newErrors.format = "Selecione o formato do curso.";
      if (!formData.completionYear)
        newErrors.completionYear = "Informe o ano de conclusão.";
      
      if (!formData.hasAnotherCourse) {
        newErrors.hasAnotherCourse = "Selecione uma opção.";
      } else if (formData.hasAnotherCourse === "Sim" && !formData.previousCourseModality) {
        newErrors.previousCourseModality = "Selecione a modalidade do curso anterior.";
      }
    }

    if (currentStep === 3) {
      if (formData.infraRating === 0) newErrors.infraRating = true;
      if (formData.teacherRating === 0) newErrors.teacherRating = true;
      if (formData.supportRating === 0) newErrors.supportRating = true;
      if (!formData.labsSufficiency)
        newErrors.labsSufficiency = "Por favor, avalie os equipamentos.";
      if (!formData.expectationMet)
        newErrors.expectationMet = "Selecione uma opção.";
      if (formData.expectationMet && !formData.expectationReason)
        newErrors.expectationReason = "Selecione o fator principal.";
    }

    if (currentStep === 4) {
      if (!formData.workedDuringCourse)
        newErrors.workedDuringCourse = "Selecione uma opção.";

      if (!formData.isStudying)
        newErrors.isStudying = "Informe se está estudando.";
      if (formData.isStudying === "Sim") {
        if (!formData.currentStudyType)
          newErrors.currentStudyType = "Qual o nível do curso?";
        if (!formData.currentStudyRelation)
          newErrors.currentStudyRelation = "Tem relação com o IFMG?";
        if (!formData.isStudyingAtIFMG)
          newErrors.isStudyingAtIFMG = "Informe se estuda no IFMG.";
        if (
          formData.isStudyingAtIFMG === "Não" &&
          !formData.studyInstitutionType
        )
          newErrors.studyInstitutionType = "Informe o tipo de instituição.";
      }

      if (!formData.workingStatus)
        newErrors.workingStatus = "Selecione sua situação de trabalho.";
      if (formData.workingStatus === "working") {
        if (!formData.jobTitle.trim())
          newErrors.jobTitle = "Informe seu cargo/função.";
        if (!formData.jobType) newErrors.jobType = "Informe o tipo de vínculo.";
        if (!formData.workModality)
          newErrors.workModality = "Informe a modalidade.";
        if (!formData.workSector)
          newErrors.workSector = "Selecione o setor de atuação.";
        if (!formData.jobRelation)
          newErrors.jobRelation = "Selecione uma opção.";
        if (!formData.salaryRange)
          newErrors.salaryRange = "Selecione a faixa salarial.";
      }
    }

    if (currentStep === 5) {
      if (!formData.wantNews) newErrors.wantNews = "Selecione uma opção.";
      if (!formData.wantEvents) newErrors.wantEvents = "Selecione uma opção.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      isValid = false;
    }
    return isValid;
  };

  const saveToGoogleSheets = async (data) => {
    if (!GOOGLE_SCRIPT_URL) return;
    try {
      await fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
    } catch (e) {
      console.error("Erro ao enviar para planilha:", e);
    }
  };

  const saveData = async () => {
    setIsSaving(true);
    try {
      const dataToSave = {
        ...formData,
        cursoFinal:
          formData.course === "Outro" ? formData.customCourse : formData.course,
        submittedAt: new Date().toISOString(),
        appVersion: "1.0",
      };

      if (GOOGLE_SCRIPT_URL) {
        await saveToGoogleSheets(dataToSave);
      }
      setIsSubmitted(true);
    } catch (error) {
      console.error("Erro geral ao salvar:", error);
      alert("Houve um erro ao enviar. Por favor, tente novamente.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleNext = () => {
    if (validateStep(step)) {
      if (step < 5) {
        setStep(step + 1);
      } else {
        saveData();
      }
    }
  };

  const handleBack = () => {
    if (step > 0) setStep(step - 1);
  };

  const renderWelcome = () => (
    <div className="text-center space-y-6 py-4 animate-fade-in px-2">
      <div className="relative w-full h-64 md:h-80 rounded-2xl overflow-hidden shadow-xl mb-6 group">
        <img
          src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&q=80&w=1932"
          alt="Grupo diverso de jovens sorrindo e olhando para a câmera"
          className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-green-900/80 via-black/20 to-transparent flex flex-col justify-end p-8">
          <p className="text-white font-extrabold text-2xl md:text-3xl drop-shadow-md text-center">
            Vem com a gente! 👋
          </p>
          <p className="text-white/90 text-sm md:text-base mt-2 font-medium">
            O IFMG quer saber por onde você anda.
          </p>
        </div>
      </div>

      <div className="max-w-2xl mx-auto space-y-4">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 tracking-tight">
          Sua história inspira o futuro.
        </h2>

        <div className="max-w-xl mx-auto leading-relaxed text-base md:text-lg text-gray-600">
          <p className="text-gray-800 font-medium mb-2">
            Responda à pesquisa de acompanhamento dos egressos do IFMG e
            fortaleça o seu diploma.
          </p>
          <p>
            É a sua chance de receber ofertas de vagas de emprego, participar de eventos promovidos pelo IFMG e contribuir para melhorar o curso para quem está chegando agora.
          </p>
        </div>

        <div className="flex justify-center items-center gap-2 text-sm text-gray-500 bg-gray-50 py-2 px-4 rounded-full mx-auto w-fit border border-gray-200">
          <Clock size={18} className="text-green-600" /> É rapidinho: leva menos
          de 3 minutos.
        </div>
      </div>

      <div className="pt-4 pb-2">
        <button
          onClick={() => setStep(1)}
          className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 md:px-16 rounded-full shadow-xl transform transition hover:-translate-y-1 text-lg md:text-xl flex items-center gap-3 mx-auto focus:ring-4 focus:ring-green-200 outline-none w-full md:w-auto justify-center"
        >
          Quero deixar minha marca <ChevronRight />
        </button>
        <p className="mt-4 text-xs text-gray-400">
          Seus dados estão protegidos (LGPD - Lei nº 13.709/2018).
        </p>
      </div>
    </div>
  );

  const renderStep1_Personal = () => (
    <div className="space-y-6 animate-slide-up">
      <div className="text-center mb-8">
        <h2 className="text-xl md:text-2xl font-bold text-gray-800 flex items-center justify-center gap-2">
          <User className="text-green-600" /> Sobre Você
        </h2>
        <p className="text-gray-500 text-sm md:text-base">
          Vamos atualizar seu contato?
        </p>
      </div>

      <div className="grid md:grid-cols-1 gap-6">
        <div className="bg-white p-4 md:p-5 rounded-xl border border-gray-100 shadow-sm space-y-4">
          <h3 className="font-semibold text-gray-800 border-b pb-2 mb-2">
            Dados de Contato
          </h3>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Nome Completo
            </label>
            <input
              type="text"
              value={formData.fullName}
              onChange={(e) => handleChange("fullName", e.target.value)}
              className={`w-full p-3 md:p-4 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none transition ${
                errors.fullName ? "border-red-500 bg-red-50" : "border-gray-300"
              }`}
              placeholder="Digite seu nome aqui"
            />
            {errors.fullName && <ErrorMessage message={errors.fullName} />}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                E-mail pessoal
              </label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => handleChange("email", e.target.value)}
                className={`w-full p-3 md:p-4 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none ${
                  errors.email ? "border-red-500 bg-red-50" : "border-gray-300"
                }`}
                placeholder="exemplo@email.com"
              />
              {errors.email && <ErrorMessage message={errors.email} />}
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                Telefone / WhatsApp
              </label>
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) => handleChange("phone", e.target.value)}
                maxLength={15}
                className={`w-full p-3 md:p-4 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none ${
                  errors.phone ? "border-red-500 bg-red-50" : "border-gray-300"
                }`}
                placeholder="(DD) 9XXXX-XXXX"
              />
              {errors.phone && <ErrorMessage message={errors.phone} />}
            </div>
          </div>
        </div>

        <div className="bg-white p-4 md:p-5 rounded-xl border border-gray-100 shadow-sm space-y-4">
          <h3 className="font-semibold text-gray-800 border-b pb-2 mb-2">
            Identidade
          </h3>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3"></label>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {GENDER_OPTIONS.map((opt) => (
                <CardOption
                  key={opt.id}
                  title={opt.id}
                  description={opt.desc}
                  selected={formData.gender === opt.id}
                  onClick={() => handleChange("gender", opt.id)}
                  compact={true}
                />
              ))}
            </div>
            {errors.gender && <ErrorMessage message={errors.gender} />}
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Qual sua cor ou raça?
            </label>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {RACES.map((r) => (
                <button
                  key={r}
                  onClick={() => handleChange("race", r)}
                  className={`p-3 rounded-lg border transition-colors text-sm font-medium ${
                    formData.race === r
                      ? "bg-green-600 text-white border-green-600 shadow-md"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                  }`}
                >
                  {r}
                </button>
              ))}
            </div>
            {errors.race && <ErrorMessage message={errors.race} />}
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Você se considera uma pessoa quilombola?
            </label>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-2">
              {["Não", "Sim", "Prefiro não informar"].map((opt) => (
                <button
                  key={opt}
                  onClick={() => handleChange("isQuilombola", opt)}
                  className={`p-3 rounded-lg border transition-colors font-medium ${
                    formData.isQuilombola === opt
                      ? "bg-green-600 text-white border-green-600 shadow-md"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                  }`}
                >
                  {opt}
                </button>
              ))}
            </div>
            {errors.isQuilombola && (
              <ErrorMessage message={errors.isQuilombola} />
            )}
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Você é Pessoa com Deficiência (PcD)?
            </label>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-2">
              {["Não", "Sim"].map((opt) => (
                <button
                  key={opt}
                  onClick={() => {
                    handleChange("isPcd", opt);
                    if (opt === "Não") handleChange("pcdType", []);
                  }}
                  className={`flex-1 p-3 rounded-lg border transition-colors font-medium ${
                    formData.isPcd === opt
                      ? "bg-green-600 text-white border-green-600 shadow-md"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                  }`}
                >
                  {opt}
                </button>
              ))}
            </div>
            {errors.isPcd && <ErrorMessage message={errors.isPcd} />}

            {formData.isPcd === "Sim" && (
              <div className="mt-4 p-4 bg-gray-50 border border-gray-200 rounded-lg animate-fade-in">
                <label className="block text-sm font-semibold text-gray-700 mb-3">
                  Selecione o(s) tipo(s) de deficiência:
                </label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  {PCD_TYPES.map((type) => {
                    const isSelected =
                      formData.pcdType && formData.pcdType.includes(type);
                    return (
                      <button
                        key={type}
                        onClick={() => {
                          let current = formData.pcdType || [];
                          if (type === "Prefiro não informar") {
                            handleChange(
                              "pcdType",
                              current.includes(type) ? [] : [type]
                            );
                          } else {
                            current = current.filter(
                              (t) => t !== "Prefiro não informar"
                            );
                            if (current.includes(type)) {
                              handleChange(
                                "pcdType",
                                current.filter((t) => t !== type)
                              );
                            } else {
                              handleChange("pcdType", [...current, type]);
                            }
                          }
                        }}
                        className={`p-3 text-sm text-left rounded-lg border transition-all flex items-center justify-between ${
                          isSelected
                            ? "bg-green-50 border-green-500 text-green-900"
                            : "bg-white border-gray-200 text-gray-600 hover:bg-gray-50"
                        }`}
                      >
                        {type}
                        {isSelected && (
                          <CheckCircle
                            size={16}
                            className="text-green-600 flex-shrink-0 ml-2"
                          />
                        )}
                      </button>
                    );
                  })}
                </div>
                {errors.pcdType && <ErrorMessage message={errors.pcdType} />}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  const renderStep2_Academic = () => {
    const recentYears = [2025, 2024, 2023, 2022, 2021, 2020];
    const selectedCampus = formData.campus;
    
    // Todas as modalidades para a pergunta adicional no final desta etapa
    const ALL_UNIQUE_MODALITIES = [...new Set(Object.values(MODALITY_LABELS))].sort();

    let rawCampusModalities = [
      ...new Set(
        COURSE_DATABASE.filter((i) => i.campus === selectedCampus).map(
          (i) => i.modality
        )
      ),
    ];
    let availableModalities = rawCampusModalities.map(
      (m) => MODALITY_LABELS[m] || m
    );
    const QUALIFICACAO_LABEL =
      "Qualificação (Carga horária menor que 360 horas)";
    if (!availableModalities.includes(QUALIFICACAO_LABEL) && selectedCampus) {
      availableModalities.push(QUALIFICACAO_LABEL);
    }
    availableModalities.sort();
    
    let rawSelectedModalities = Object.keys(MODALITY_LABELS).filter(
      (k) => MODALITY_LABELS[k] === formData.modality
    );
    if (rawSelectedModalities.length === 0)
      rawSelectedModalities = [formData.modality];
    
    const isQualificacao = formData.modality && formData.modality.includes("Qualificação");

    let availableCourses = [];
    if (!isQualificacao) {
      availableCourses = [
        ...new Set(
          COURSE_DATABASE.filter(
            (i) =>
              i.campus === selectedCampus &&
              rawSelectedModalities.includes(i.modality)
          ).map((i) => i.course)
        ),
      ];
    }
    availableCourses.sort();
    
    let availableFormats = [];
    if (formData.course && formData.course !== "Outro" && !isQualificacao) {
      availableFormats = [
        ...new Set(
          COURSE_DATABASE.filter(
            (i) =>
              i.campus === selectedCampus &&
              rawSelectedModalities.includes(i.modality) &&
              i.course === formData.course
          ).map((i) => (i.format === "EaD" ? "A Distância (EaD)" : i.format))
        ),
      ];
    } else if (formData.course === "Outro" || isQualificacao) {
      availableFormats = ["Presencial", "A Distância (EaD)"];
    }

    return (
      <div className="space-y-6 animate-slide-up">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-gray-800 flex items-center justify-center gap-2">
            <BookOpen className="text-green-600" /> Sua Formação
          </h2>
          <p className="text-gray-500 text-sm md:text-base">
            Conte sobre o curso que você concluiu no IFMG.
          </p>
        </div>

        <div className="space-y-5">
          <div className="bg-white p-4 md:p-5 rounded-xl border border-gray-100 shadow-sm space-y-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                Em qual cidade/campus você estudou?
              </label>
              <select
                value={formData.campus}
                onChange={(e) => {
                  handleChange("campus", e.target.value);
                  handleChange("modality", "");
                  handleChange("course", "");
                  handleChange("customCourse", "");
                  handleChange("format", "");
                }}
                className={`w-full p-3 md:p-4 border rounded-lg bg-white focus:ring-2 focus:ring-green-500 outline-none ${
                  errors.campus ? "border-red-500 bg-red-50" : "border-gray-300"
                }`}
              >
                <option value="">Selecione o Campus...</option>
                {UNIQUE_CAMPUSES.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
              {errors.campus && <ErrorMessage message={errors.campus} />}
            </div>

            <div
              className={!formData.campus ? "opacity-50" : "animate-fade-in"}
            >
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                Qual foi a modalidade?
              </label>
              <select
                value={formData.modality}
                onChange={(e) => {
                  const newModality = e.target.value;
                  handleChange("modality", newModality);
                  handleChange("format", "");
                  if (newModality.includes("Qualificação") || newModality === "FIC") {
                    handleChange("course", "Outro");
                    handleChange("customCourse", "");
                  } else {
                    handleChange("course", "");
                    handleChange("customCourse", "");
                  }
                }}
                className={`w-full p-3 md:p-4 border rounded-lg bg-white focus:ring-2 focus:ring-green-500 outline-none disabled:bg-gray-100 disabled:cursor-not-allowed ${
                  errors.modality
                    ? "border-red-500 bg-red-50"
                    : "border-gray-300"
                }`}
                disabled={!formData.campus}
              >
                <option value="">
                  {!formData.campus
                    ? "Selecione o campus acima primeiro"
                    : "Selecione para ver as opções..."}
                </option>
                {availableModalities.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
              {errors.modality && <ErrorMessage message={errors.modality} />}
            </div>

            <div
              className={!formData.modality ? "opacity-50" : "animate-fade-in"}
            >
              {!isQualificacao && (
                <>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    Qual foi o último curso que você concluiu no IFMG?
                  </label>
                  <select
                    value={formData.course}
                    onChange={(e) => {
                      const newCourse = e.target.value;
                      handleChange("course", newCourse);
                      handleChange("format", "");
                      if (newCourse && newCourse !== "Outro") {
                        const formats = [
                          ...new Set(
                            COURSE_DATABASE.filter(
                              (i) =>
                                i.campus === selectedCampus &&
                                rawSelectedModalities.includes(i.modality) &&
                                i.course === newCourse
                            ).map((i) =>
                              i.format === "EaD" ? "A Distância (EaD)" : i.format
                            )
                          ),
                        ];
                        if (formats.length === 1) {
                          handleChange("format", formats[0]);
                        }
                      }
                    }}
                    className={`w-full p-3 md:p-4 border rounded-lg bg-white focus:ring-2 focus:ring-green-500 outline-none disabled:bg-gray-100 disabled:cursor-not-allowed ${
                      errors.course ? "border-red-500 bg-red-50" : "border-gray-300"
                    }`}
                    disabled={!formData.modality}
                  >
                    <option value="">
                      {!formData.modality
                        ? "Selecione a modalidade acima primeiro"
                        : "Selecione seu curso..."}
                    </option>
                    {availableCourses.map((c) => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                    <option value="Outro">Outro / Não encontrei na lista</option>
                  </select>
                  {errors.course && <ErrorMessage message={errors.course} />}
                </>
              )}

              {(formData.course === "Outro" || isQualificacao) && (
                <div className={isQualificacao ? "mt-0" : "mt-3 animate-fade-in"}>
                  {isQualificacao && (
                    <label className="block text-sm font-semibold text-gray-700 mb-1">
                      Qual foi o último curso que você concluiu no IFMG?
                    </label>
                  )}
                  <input
                    type="text"
                    value={formData.customCourse}
                    onChange={(e) =>
                      handleChange("customCourse", e.target.value)
                    }
                    className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none transition ${
                      errors.customCourse
                        ? "border-red-500 bg-red-50"
                        : "border-gray-300"
                    }`}
                    placeholder="Digite o nome exato do seu curso"
                  />
                  {errors.customCourse && (
                    <ErrorMessage message={errors.customCourse} />
                  )}
                </div>
              )}
            </div>

            {(formData.course || isQualificacao) && (
              <div className="animate-fade-in">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Formato do Curso
                </label>
                <div className="flex gap-3">
                  {availableFormats.map((fmt) => (
                    <button
                      key={fmt}
                      onClick={() => handleChange("format", fmt)}
                      className={`flex-1 p-3 rounded-lg border transition-colors font-medium ${
                        formData.format === fmt
                          ? "bg-green-600 text-white border-green-600 shadow-md"
                          : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                      }`}
                    >
                      {fmt}
                    </button>
                  ))}
                </div>
                {errors.format && <ErrorMessage message={errors.format} />}
              </div>
            )}

            {formData.campus && (
              <div className="animate-fade-in border-t border-gray-100 pt-4 mt-2">
                <label className="block text-sm font-semibold text-gray-700 mb-3">
                  Ano de Conclusão
                </label>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mb-3">
                  {recentYears.map((yr) => {
                    const isSelected =
                      formData.completionYear === yr.toString();
                    return (
                      <button
                        key={yr}
                        onClick={() => {
                          if (isSelected) {
                            handleChange("completionYear", "");
                          } else {
                            handleChange("completionYear", yr.toString());
                          }
                        }}
                        className={`px-3 py-3 rounded-lg text-sm font-medium border transition-all ${
                          isSelected
                            ? "bg-green-600 text-white border-green-600 shadow-md transform scale-[1.02]"
                            : "bg-white text-gray-600 hover:bg-gray-50 border-gray-200"
                        }`}
                      >
                        {yr}
                      </button>
                    );
                  })}
                </div>

                <div className="relative my-4 flex items-center gap-3">
                  <div className="flex-grow border-t border-gray-200"></div>
                  <span className="text-xs text-gray-400 font-bold uppercase tracking-widest">
                    OU
                  </span>
                  <div className="flex-grow border-t border-gray-200"></div>
                </div>

                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={4}
                  placeholder="Formou antes de 2020? Digite o ano..."
                  disabled={recentYears.includes(
                    parseInt(formData.completionYear)
                  )}
                  className={`w-full p-3 text-sm rounded-lg border transition-all focus:ring-2 focus:ring-green-500 outline-none
                    ${
                      recentYears.includes(parseInt(formData.completionYear))
                        ? "bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed"
                        : !recentYears.includes(
                            parseInt(formData.completionYear)
                          ) && formData.completionYear !== ""
                        ? "border-green-600 bg-green-50 text-green-900 font-medium"
                        : "border-gray-300 bg-white text-gray-600"
                    }`}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "");
                    handleChange("completionYear", val);
                  }}
                  value={
                    recentYears.includes(parseInt(formData.completionYear))
                      ? ""
                      : formData.completionYear
                  }
                />
                {recentYears.includes(parseInt(formData.completionYear)) && (
                  <p className="text-xs text-gray-400 mt-1">
                    Desmarque o ano acima para poder digitar.
                  </p>
                )}
                {errors.completionYear && (
                  <ErrorMessage message={errors.completionYear} />
                )}
              </div>
            )}
          </div>

          <div className="bg-white p-4 md:p-5 rounded-xl border border-gray-100 shadow-sm animate-fade-in">
            <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
              <Beaker size={18} className="text-green-600" /> O que você
              realizou durante o curso?
            </label>
            <p className="text-xs text-gray-500 mb-3">
              Marque todas as opções que se aplicam.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {PRACTICE_TYPES.map((practice) => {
                const isSelected = formData.practices.includes(practice);
                return (
                  <button
                    key={practice}
                    onClick={() => toggleSelection("practices", practice)}
                    className={`p-3 text-sm text-left rounded-lg border transition-all flex items-center justify-between ${
                      isSelected
                        ? "bg-green-50 border-green-500 text-green-900"
                        : "bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100"
                    }`}
                  >
                    {practice}
                    {isSelected && (
                      <CheckCircle
                        size={16}
                        className="text-green-600 flex-shrink-0 ml-2"
                      />
                    )}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="bg-white p-4 md:p-5 rounded-xl border border-gray-100 shadow-sm animate-fade-in">
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Você já concluiu outro curso no IFMG além deste?
            </label>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-2">
              {["Não", "Sim"].map((opt) => (
                <button
                  key={opt}
                  onClick={() => {
                    handleChange("hasAnotherCourse", opt);
                    if (opt === "Não") handleChange("previousCourseModality", "");
                  }}
                  className={`flex-1 p-3 rounded-lg border transition-colors font-medium ${
                    formData.hasAnotherCourse === opt
                      ? "bg-green-600 text-white border-green-600 shadow-md"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                  }`}
                >
                  {opt}
                </button>
              ))}
            </div>
            {errors.hasAnotherCourse && (
              <ErrorMessage message={errors.hasAnotherCourse} />
            )}

            {formData.hasAnotherCourse === "Sim" && (
              <div className="mt-5 animate-fade-in border-t border-gray-100 pt-5">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Qual foi a modalidade desse outro curso?
                </label>
                <select
                  value={formData.previousCourseModality}
                  onChange={(e) => handleChange("previousCourseModality", e.target.value)}
                  className={`w-full p-3 md:p-4 border rounded-lg bg-white focus:ring-2 focus:ring-green-500 outline-none ${
                    errors.previousCourseModality ? "border-red-500" : "border-gray-300"
                  }`}
                >
                  <option value="">Selecione a modalidade...</option>
                  {ALL_UNIQUE_MODALITIES.map(m => (
                    <option key={m} value={m}>{m}</option>
                  ))}
                </select>
                {errors.previousCourseModality && (
                  <ErrorMessage message={errors.previousCourseModality} />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderStep3_Evaluation = () => (
    <div className="space-y-6 md:space-y-8 animate-slide-up">
      <div className="text-center mb-6 md:mb-8">
        <h2 className="text-xl md:text-2xl font-bold text-gray-800 flex items-center justify-center gap-2">
          <Star className="text-green-600" /> Avaliação & Impacto
        </h2>
        <p className="text-gray-500 text-sm md:text-base">
          Sua sinceridade é a nossa melhor ferramenta de gestão.
        </p>
      </div>

      <div className="grid gap-4 md:gap-6">
        <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100">
          <h4 className="font-bold text-gray-800 mb-4 border-b pb-2">
            Satisfação Geral
          </h4>
          <div className="space-y-6">
            <div>
              <label className="block font-medium text-sm text-gray-700 mb-1">
                Infraestrutura
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Salas de aula, bibliotecas, banheiros, cantina e áreas comuns.
              </p>
              <RatingStars
                value={formData.infraRating}
                onChange={handleChange}
                name="infraRating"
                error={errors.infraRating}
              />
            </div>
            <div>
              <label className="block font-medium text-sm text-gray-700 mb-1">
                Corpo Docente
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Domínio do conteúdo, didática, assiduidade e relacionamento.
              </p>
              <RatingStars
                value={formData.teacherRating}
                onChange={handleChange}
                name="teacherRating"
                error={errors.teacherRating}
              />
            </div>
            <div>
              <label className="block font-medium text-sm text-gray-700 mb-1">
                Apoio ao Estudante
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Atendimento da secretaria, coordenação, assistência estudantil e
                pedagógica.
              </p>
              <RatingStars
                value={formData.supportRating}
                onChange={handleChange}
                name="supportRating"
                error={errors.supportRating}
              />
            </div>
          </div>
        </div>

        <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100">
          <label className="block font-medium text-gray-800 mb-3 flex items-center gap-2">
            <Beaker size={20} className="text-green-600" /> Aulas Práticas
          </label>
          <p className="text-sm text-gray-500 mb-4">
            Os laboratórios e equipamentos eram suficientes?
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {LAB_SUFFICIENCY_OPTIONS.map((opt) => {
              const isSelected = formData.labsSufficiency === opt.label;
              const IconComponent = opt.icon;
              return (
                <button
                  key={opt.label}
                  onClick={() => handleChange("labsSufficiency", opt.label)}
                  className={`p-3 rounded-lg border text-left flex items-center gap-3 transition-all ${
                    isSelected
                      ? "border-green-600 bg-green-50"
                      : "border-gray-200 hover:bg-gray-50"
                  }`}
                >
                  <IconComponent
                    className={`${
                      isSelected ? "text-green-600" : "text-gray-400"
                    } flex-shrink-0`}
                    size={20}
                  />
                  <span
                    className={`text-sm ${
                      isSelected
                        ? "font-semibold text-gray-900"
                        : "text-gray-600"
                    }`}
                  >
                    {opt.label}
                  </span>
                </button>
              );
            })}
          </div>
          {errors.labsSufficiency && (
            <ErrorMessage message={errors.labsSufficiency} />
          )}
        </div>

        <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100 space-y-6">
          <h4 className="font-bold text-gray-800 border-b pb-2 flex items-center gap-2 text-sm md:text-base">
            <Lightbulb className="text-yellow-500 flex-shrink-0" size={20} />{" "}
            Competências & Mercado
          </h4>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Quais conhecimentos do curso você{" "}
              <span className="text-green-600">mais utiliza</span> hoje?
            </label>
            <p className="text-xs text-gray-400 mb-3">
              Selecione até 3 opções.
            </p>
            <div className="flex flex-wrap gap-2">
              {SKILLS_LIST.map((skill) => {
                const isActive = formData.skillsUsed.includes(skill);
                return (
                  <button
                    key={skill}
                    onClick={() => {
                      if (isActive) toggleSelection("skillsUsed", skill);
                      else if (formData.skillsUsed.length < 3)
                        toggleSelection("skillsUsed", skill);
                    }}
                    className={`px-3 py-2 rounded-full text-xs font-medium border transition-all flex items-center gap-1 ${
                      isActive
                        ? "bg-green-100 text-green-800 border-green-300"
                        : "bg-white text-gray-600 border-gray-200 hover:border-gray-400"
                    }`}
                  >
                    {skill}
                  </button>
                );
              })}
            </div>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              O que poderia ter sido{" "}
              <span className="text-red-600">mais explorado</span>?
            </label>
            <p className="text-xs text-gray-400 mb-3">
              Selecione até 3 opções.
            </p>
            <div className="flex flex-wrap gap-2">
              {SKILLS_LIST.map((skill) => {
                const isActive = formData.skillsGap.includes(skill);
                return (
                  <button
                    key={skill}
                    onClick={() => {
                      if (isActive) toggleSelection("skillsGap", skill);
                      else if (formData.skillsGap.length < 3)
                        toggleSelection("skillsGap", skill);
                    }}
                    className={`px-3 py-2 rounded-full text-xs font-medium border transition-all ${
                      isActive
                        ? "bg-red-100 text-red-800 border-red-300"
                        : "bg-white text-gray-600 border-gray-200 hover:border-gray-400"
                    }`}
                  >
                    {skill}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100">
          <label className="block font-medium text-gray-800 mb-4 text-sm md:text-base">
            No geral, o curso atendeu suas expectativas?
          </label>
          <div className="flex flex-col sm:flex-row gap-3">
            {[
              {
                val: "superou",
                label: "Superou!",
                icon: Smile,
                color: "text-green-600",
                activeClass:
                  "border-green-600 bg-green-50 ring-1 ring-green-600 shadow-md",
              },
              {
                val: "atendeu",
                label: "Sim, atendeu",
                icon: Meh,
                color: "text-yellow-600",
                activeClass:
                  "border-yellow-500 bg-yellow-50 ring-1 ring-yellow-500 shadow-md",
              },
              {
                val: "nao",
                label: "Não atendeu",
                icon: Frown,
                color: "text-red-600",
                activeClass:
                  "border-red-600 bg-red-50 ring-1 ring-red-600 shadow-md",
              },
            ].map((opt) => {
              const IconComponent = opt.icon;
              return (
                <button
                  key={opt.val}
                  onClick={() => handleChange("expectationMet", opt.val)}
                  className={`flex-1 p-4 rounded-xl border-2 flex flex-row sm:flex-col items-center justify-center gap-3 sm:gap-2 transition-all ${
                    formData.expectationMet === opt.val
                      ? opt.activeClass
                      : "border-gray-200 hover:border-gray-300"
                  }`}
                >
                  <IconComponent className={opt.color} size={28} />
                  <span className="font-medium text-sm text-gray-700">
                    {opt.label}
                  </span>
                </button>
              );
            })}
          </div>
          {errors.expectationMet && (
            <ErrorMessage message={errors.expectationMet} />
          )}

          {formData.expectationMet && (
            <div className="mt-6 animate-fade-in border-t border-gray-100 pt-5">
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                Qual dos pontos abaixo mais influenciou essa sua avaliação?
              </label>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {[
                  "Infraestrutura",
                  "Corpo Docente",
                  "Apoio ao Estudante",
                  "Aulas Práticas/Equipamentos",
                  "Outro",
                ].map((opt) => (
                  <button
                    key={opt}
                    onClick={() => handleChange("expectationReason", opt)}
                    className={`p-3 rounded-lg border transition-colors text-sm font-medium ${
                      formData.expectationReason === opt
                        ? "bg-green-600 text-white border-green-600 shadow-md"
                        : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                    }`}
                  >
                    {opt}
                  </button>
                ))}
              </div>
              {errors.expectationReason && (
                <ErrorMessage message={errors.expectationReason} />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderStep4_Career = () => (
    <div className="space-y-6 animate-slide-up">
      <div className="text-center mb-6 md:mb-8">
        <h2 className="text-xl md:text-2xl font-bold text-gray-800 flex items-center justify-center gap-2">
          <Briefcase className="text-green-600" /> Carreira e Estudos
        </h2>
        <p className="text-gray-500 text-sm md:text-base">
          Mapeando a verticalização e empregabilidade.
        </p>
      </div>

      <div className="grid gap-4 md:gap-6">
        <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100">
          <label className="block text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
            <Clock className="text-green-600 flex-shrink-0" /> Durante o curso
          </label>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Você já trabalhava enquanto estudava no IFMG?
            </label>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {[
                "Sim, na minha área",
                "Sim, em outra área",
                "Não trabalhava",
              ].map((opt) => (
                <button
                  key={opt}
                  onClick={() => handleChange("workedDuringCourse", opt)}
                  className={`flex-1 p-3 rounded-lg border transition-colors text-sm font-medium ${
                    formData.workedDuringCourse === opt
                      ? "bg-green-600 text-white border-green-600 shadow-md"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                  }`}
                >
                  {opt}
                </button>
              ))}
            </div>
            {errors.workedDuringCourse && (
              <ErrorMessage message={errors.workedDuringCourse} />
            )}
          </div>
        </div>

        <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100">
          <label className="block text-base md:text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
            <GraduationCap className="text-green-600 flex-shrink-0" /> Você está
            estudando atualmente?
          </label>
          <div className="flex flex-col sm:flex-row gap-3 mb-4">
            {["Não", "Sim"].map((opt) => (
              <button
                key={opt}
                onClick={() => {
                  handleChange("isStudying", opt);
                  if (opt === "Não") {
                    handleChange("currentStudyType", "");
                    handleChange("currentStudyRelation", "");
                    handleChange("isStudyingAtIFMG", "");
                    handleChange("studyInstitutionType", "");
                  }
                }}
                className={`flex-1 p-3 rounded-lg border transition-colors font-medium ${
                  formData.isStudying === opt
                    ? "bg-green-600 text-white border-green-600 shadow-md"
                    : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                }`}
              >
                {opt}
              </button>
            ))}
          </div>
          {errors.isStudying && <ErrorMessage message={errors.isStudying} />}

          {formData.isStudying === "Sim" && (
            <div className="space-y-4 animate-fade-in bg-gray-50 p-4 rounded-lg border border-gray-200 mt-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Qual o nível do curso?
                </label>
                <select
                  value={formData.currentStudyType}
                  onChange={(e) =>
                    handleChange("currentStudyType", e.target.value)
                  }
                  className={`w-full p-3 border rounded-lg bg-white focus:ring-2 focus:ring-green-500 outline-none ${
                    errors.currentStudyType
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                >
                  <option value="">Selecione...</option>
                  {STUDY_TYPES.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
                </select>
                {errors.currentStudyType && (
                  <ErrorMessage message={errors.currentStudyType} />
                )}
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Tem relação com sua formação no IFMG?
                </label>
                <div className="flex flex-col sm:flex-row gap-2">
                  {["Sim, Total", "Parcialmente", "Não"].map((opt) => (
                    <button
                      key={opt}
                      onClick={() => handleChange("currentStudyRelation", opt)}
                      className={`flex-1 py-3 sm:py-2 text-sm rounded border ${
                        formData.currentStudyRelation === opt
                          ? "bg-green-600 text-white border-green-600"
                          : "bg-white border-gray-300 hover:bg-gray-50"
                      }`}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                {errors.currentStudyRelation && (
                  <ErrorMessage message={errors.currentStudyRelation} />
                )}
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Você continua estudando no IFMG?
                </label>
                <div className="flex flex-col sm:flex-row gap-2">
                  {["Sim", "Não"].map((opt) => (
                    <button
                      key={opt}
                      onClick={() => {
                        handleChange("isStudyingAtIFMG", opt);
                        if (opt === "Sim")
                          handleChange("studyInstitutionType", "");
                      }}
                      className={`flex-1 py-3 sm:py-2 text-sm rounded border ${
                        formData.isStudyingAtIFMG === opt
                          ? "bg-green-600 text-white border-green-600"
                          : "bg-white border-gray-300 hover:bg-gray-50"
                      }`}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                {errors.isStudyingAtIFMG && (
                  <ErrorMessage message={errors.isStudyingAtIFMG} />
                )}
              </div>

              {formData.isStudyingAtIFMG === "Não" && (
                <div className="animate-fade-in mt-1">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    A instituição é Pública ou Privada?
                  </label>
                  <div className="flex flex-col sm:flex-row gap-2">
                    {["Pública", "Privada"].map((opt) => (
                      <button
                        key={opt}
                        onClick={() =>
                          handleChange("studyInstitutionType", opt)
                        }
                        className={`flex-1 py-3 sm:py-2 text-sm rounded border ${
                          formData.studyInstitutionType === opt
                            ? "bg-green-600 text-white border-green-600"
                            : "bg-white border-gray-300 hover:bg-gray-50"
                        }`}
                      >
                        {opt}
                      </button>
                    ))}
                  </div>
                  {errors.studyInstitutionType && (
                    <ErrorMessage message={errors.studyInstitutionType} />
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100">
          <label className="block text-base md:text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
            <Briefcase className="text-green-600 flex-shrink-0" /> Situação de
            Trabalho
          </label>
          <div className="grid gap-3 mb-4">
            <CardOption
              title="Estou trabalhando"
              icon={Briefcase}
              selected={formData.workingStatus === "working"}
              onClick={() => handleChange("workingStatus", "working")}
            />
            <CardOption
              title="Estou procurando emprego"
              icon={MapPin}
              selected={formData.workingStatus === "searching"}
              onClick={() => handleChange("workingStatus", "searching")}
            />
            <CardOption
              title="Não estou trabalhando"
              icon={User}
              selected={formData.workingStatus === "not_working"}
              onClick={() => handleChange("workingStatus", "not_working")}
            />
          </div>
          {errors.workingStatus && (
            <ErrorMessage message={errors.workingStatus} />
          )}

          {formData.workingStatus === "working" && (
            <div className="bg-gray-50 p-4 md:p-5 rounded-lg border border-gray-200 space-y-5 animate-fade-in mt-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Qual o seu cargo/função atual?
                </label>
                <input
                  type="text"
                  value={formData.jobTitle}
                  onChange={(e) => handleChange("jobTitle", e.target.value)}
                  className={`w-full p-3 border rounded-lg bg-white focus:ring-2 focus:ring-green-500 outline-none ${
                    errors.jobTitle
                      ? "border-red-500 bg-red-50"
                      : "border-gray-300"
                  }`}
                  placeholder="Ex: Analista de Dados, Técnico em Mecânica..."
                />
                {errors.jobTitle && <ErrorMessage message={errors.jobTitle} />}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    Qual seu vínculo?
                  </label>
                  <select
                    value={formData.jobType}
                    onChange={(e) => handleChange("jobType", e.target.value)}
                    className={`w-full p-3 border rounded-lg bg-white focus:ring-2 focus:ring-green-500 outline-none ${
                      errors.jobType ? "border-red-500" : "border-gray-300"
                    }`}
                  >
                    <option value="">Selecione...</option>
                    {JOB_TYPES.map((t) => (
                      <option key={t} value={t}>
                        {t}
                      </option>
                    ))}
                  </select>
                  {errors.jobType && <ErrorMessage message={errors.jobType} />}
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    Modalidade
                  </label>
                  <div className="flex gap-1">
                    {["Presencial", "Remoto", "Híbrido"].map((mod) => (
                      <button
                        key={mod}
                        onClick={() => handleChange("workModality", mod)}
                        className={`flex-1 py-3 text-xs sm:text-sm rounded border ${
                          formData.workModality === mod
                            ? "bg-green-600 text-white border-green-600 shadow-md"
                            : "bg-white border-gray-300 hover:bg-gray-50"
                        }`}
                      >
                        {mod}
                      </button>
                    ))}
                  </div>
                  {errors.workModality && (
                    <ErrorMessage message={errors.workModality} />
                  )}
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Em qual setor você atua?
                </label>
                <div className="flex flex-col sm:flex-row gap-2">
                  {["Indústria", "Comércio", "Serviços", "Outro"].map((opt) => (
                    <button
                      key={opt}
                      onClick={() => handleChange("workSector", opt)}
                      className={`flex-1 py-3 px-4 text-sm text-center rounded-lg border font-medium transition-colors ${
                        formData.workSector === opt
                          ? "bg-green-600 text-white border-green-600 shadow-md"
                          : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                      }`}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                {errors.workSector && (
                  <ErrorMessage message={errors.workSector} />
                )}
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  O trabalho tem relação com o curso?
                </label>
                <div className="flex flex-col gap-2">
                  {[
                    { label: "Sim, aplico tudo que aprendi", val: "total" },
                    {
                      label: "Sim, aplico parte do conhecimento",
                      val: "partial",
                    },
                    { label: "Não, área totalmente diferente", val: "none" },
                  ].map((opt) => (
                    <button
                      key={opt.val}
                      onClick={() => handleChange("jobRelation", opt.val)}
                      className={`flex-1 py-3 px-4 text-sm text-left rounded-lg border font-medium transition-colors flex items-center justify-between ${
                        formData.jobRelation === opt.val
                          ? "bg-green-600 text-white border-green-600 shadow-md"
                          : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                      }`}
                    >
                      {opt.label}
                      {formData.jobRelation === opt.val && (
                        <CheckCircle size={16} className="text-green-300" />
                      )}
                    </button>
                  ))}
                </div>
                {errors.jobRelation && (
                  <ErrorMessage message={errors.jobRelation} />
                )}
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Faixa salarial (bruto)
                </label>
                <select
                  value={formData.salaryRange}
                  onChange={(e) => handleChange("salaryRange", e.target.value)}
                  className={`w-full p-4 border rounded-lg bg-white focus:ring-2 focus:ring-green-500 outline-none ${
                    errors.salaryRange ? "border-red-500" : "border-gray-300"
                  }`}
                >
                  <option value="">Selecione...</option>
                  <option>Até 1 salário mínimo: Até R$ 1.621</option>
                  <option>
                    Mais de 1 a 2 salários mínimos: R$ 1.622 a R$ 3.242
                  </option>
                  <option>
                    Mais de 2 a 5 salários mínimos: R$ 3.243 a R$ 8.105
                  </option>
                  <option>
                    Mais de 5 a 10 salários mínimos: R$ 8.106 a R$ 16.210
                  </option>
                  <option>
                    Acima de 10 salários mínimos: Mais de R$ 16.210
                  </option>
                </select>
                {errors.salaryRange && (
                  <ErrorMessage message={errors.salaryRange} />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderStep5_Connection = () => (
    <div className="space-y-6 animate-slide-up">
      <div className="text-center mb-6 md:mb-8">
        <h2 className="text-xl md:text-2xl font-bold text-gray-800 flex items-center justify-center gap-2">
          <Send className="text-green-600" /> Manter Contato
        </h2>
        <p className="text-gray-500 text-sm md:text-base">
          Oportunidades exclusivas para quem faz parte da nossa rede.
        </p>
      </div>

      <div className="space-y-4 md:space-y-6">
        <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100">
          <label className="block text-base md:text-lg font-semibold text-gray-800 mb-2 flex items-center gap-2">
            <Briefcase className="text-green-600 flex-shrink-0" /> Você gostaria
            de receber vagas de emprego?
          </label>
          <p className="text-sm text-gray-500 mb-4">
            Enviaremos vagas de emprego na sua área.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            {["Não", "Sim"].map((opt) => (
              <button
                key={opt}
                onClick={() => handleChange("wantNews", opt)}
                className={`flex-1 p-3 rounded-lg border transition-colors font-medium ${
                  formData.wantNews === opt
                    ? "bg-green-600 text-white border-green-600 shadow-md"
                    : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                }`}
              >
                {opt}
              </button>
            ))}
          </div>
          {errors.wantNews && <ErrorMessage message={errors.wantNews} />}
        </div>

        <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100">
          <label className="block text-base md:text-lg font-semibold text-gray-800 mb-2 flex items-center gap-2">
            <BellRing className="text-green-600 flex-shrink-0" /> Aceita receber
            convites para eventos?
          </label>
          <p className="text-sm text-gray-500 mb-4">
            Reencontros, palestras e networking com ex-alunos.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            {["Não", "Sim"].map((opt) => (
              <button
                key={opt}
                onClick={() => {
                  handleChange("wantEvents", opt);
                  if (opt === "Não") {
                    handleChange("eventType", "");
                    handleChange("availableMonths", []);
                  }
                }}
                className={`flex-1 p-3 rounded-lg border transition-colors font-medium ${
                  formData.wantEvents === opt
                    ? "bg-green-600 text-white border-green-600 shadow-md"
                    : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                }`}
              >
                {opt}
              </button>
            ))}
          </div>
          {errors.wantEvents && <ErrorMessage message={errors.wantEvents} />}

          {formData.wantEvents === "Sim" && (
            <div className="mt-5 space-y-6 animate-fade-in border-t border-gray-100 pt-5">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-3">
                  Como você gostaria de participar dos eventos?
                </label>
                <div className="flex flex-wrap gap-2">
                  {["Presencial", "Online", "Híbrido"].map((fmt) => (
                    <button
                      key={fmt}
                      onClick={() => handleChange("eventType", fmt)}
                      className={`flex-1 sm:flex-none px-4 py-2.5 rounded-lg sm:rounded-full text-sm border font-medium transition-colors ${
                        formData.eventType === fmt
                          ? "bg-green-600 text-white border-green-600 shadow-md"
                          : "bg-white text-gray-600 border-gray-300 hover:bg-green-50"
                      }`}
                    >
                      {fmt}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                  <Calendar size={16} className="text-green-600" /> Em quais
                  meses você gostaria de participar dos eventos? (Pode marcar
                  mais de uma opção)
                </label>
                <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
                  {MONTHS.map((month) => {
                    const isSelected =
                      formData.availableMonths?.includes(month);
                    return (
                      <button
                        key={month}
                        onClick={() =>
                          toggleSelection("availableMonths", month)
                        }
                        className={`py-3 sm:py-2 px-1 text-sm rounded border transition-colors ${
                          isSelected
                            ? "bg-green-600 text-white border-green-600 font-bold shadow-md"
                            : "bg-white text-gray-500 border-gray-200 hover:border-green-400"
                        }`}
                      >
                        {month}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100">
          <label className="block text-base md:text-lg font-semibold text-gray-800 mb-2">
            Tem alguma sugestão pra gente? (Opcional)
          </label>
          <p className="text-sm text-gray-500 mb-4">
            Sua ideia é muito bem-vinda para melhorarmos o IFMG.
          </p>
          <textarea
            rows="3"
            className="w-full p-4 border border-gray-300 rounded-lg focus:ring-green-500 focus:border-green-500 outline-none text-sm md:text-base transition"
            placeholder="Escreva sua sugestão aqui..."
            value={formData.suggestions}
            onChange={(e) => handleChange("suggestions", e.target.value)}
          ></textarea>
        </div>
      </div>
    </div>
  );

  const renderSuccess = () => (
    <div className="text-center py-8 md:py-12 animate-fade-in space-y-8 px-4 max-w-lg mx-auto">
      <div>
        <h2 className="text-2xl md:text-3xl font-black text-gray-800 mb-2 leading-tight">
          {formData.fullName ? formData.fullName.split(" ")[0] : "Aluno"},
          agradecemos pela sua participação na pesquisa! 🎉
        </h2>
      </div>

      <div className="bg-yellow-50 border-2 border-yellow-300 p-5 rounded-2xl shadow-sm text-left">
        <p className="text-gray-800 text-sm md:text-base font-medium">
          📸 <strong>Tire um print do selo abaixo</strong> e poste nas suas
          redes sociais! Ajude a fortalecer nossa comunidade convocando seus
          colegas de turma para participarem da pesquisa.
        </p>
      </div>

      <div className="transform transition-transform hover:scale-105">
        <IfmgBadge />
      </div>

      <div>
        <p className="text-sm text-gray-600 font-medium">
          O texto do convite já está pronto para você compartilhar. Escolha sua
          rede favorita:
        </p>
      </div>

      <div className="flex flex-col gap-3 w-full mt-4">
        <button
          onClick={handleCopyLink}
          className="flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-800 font-bold py-3 px-6 rounded-xl transition-all text-sm md:text-base border-2 border-gray-300 shadow-sm"
        >
          {copied ? (
            <Check size={20} className="text-green-600" />
          ) : (
            <Copy size={20} />
          )}
          {copied ? "Link Copiado!" : "Copiar Link da Pesquisa"}
        </button>
        <button
          onClick={handleWhatsAppShare}
          className="flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold py-3 px-6 rounded-xl transition-all shadow-md text-sm md:text-base"
        >
          <MessageCircle size={22} /> Enviar convite no WhatsApp
        </button>
        <button
          onClick={handleInstagramShare}
          className="flex items-center justify-center gap-2 bg-gradient-to-r from-[#833ab4] via-[#fd1d1d] to-[#fcb045] hover:opacity-90 text-white font-bold py-3 px-6 rounded-xl transition-all shadow-md text-sm md:text-base relative overflow-hidden group"
        >
          <Instagram size={22} className="relative z-10" />{" "}
          <span className="relative z-10">Postar no Instagram</span>
        </button>
        <button
          onClick={handleFacebookShare}
          className="flex items-center justify-center gap-2 bg-[#1877F2] hover:bg-[#166fe5] text-white font-bold py-3 px-6 rounded-xl transition-all shadow-md text-sm md:text-base"
        >
          <Facebook size={22} fill="currentColor" /> Compartilhar no Facebook
        </button>
        <button
          onClick={handleLinkedInShare}
          className="flex items-center justify-center gap-2 bg-[#0077b5] hover:bg-[#006097] text-white font-bold py-3 px-6 rounded-xl transition-all shadow-md text-sm md:text-base"
        >
          <Linkedin size={22} fill="currentColor" /> Postar no LinkedIn
        </button>
        <button
          onClick={handleTikTokShare}
          className="flex items-center justify-center gap-2 bg-black hover:bg-gray-800 text-white font-bold py-3 px-6 rounded-xl transition-all shadow-md text-sm md:text-base"
        >
          <svg fill="currentColor" width="22" height="22" viewBox="0 0 24 24">
            <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.01.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 2.22-.71 4.46-1.92 6.25-1.2 1.8-2.92 3.15-4.96 3.94-2.03.78-4.28.94-6.38.45-2.1-.49-4.01-1.6-5.41-3.23-1.41-1.64-2.18-3.74-2.22-5.91-.04-2.16.66-4.28 1.99-5.98 1.33-1.7 3.2-2.9 5.25-3.5 2.05-.6 4.3-.65 6.38-.17v4.06c-3.13-1.14-6.66-.08-8.58 2.57-1.91 2.65-1.62 6.38.74 8.7 2.36 2.33 6.07 2.31 8.4-.04 2.33-2.36 2.45-6.07.28-8.57-.45-.49-.97-.93-1.52-1.32-.01-5.46-.02-10.92.01-16.38z" />
          </svg>
          Compartilhar no TikTok
        </button>
      </div>

      <button
        onClick={() => window.location.reload()}
        className="mt-8 text-gray-400 text-sm hover:text-green-600 transition-colors underline block mx-auto"
      >
        Voltar ao início
      </button>
    </div>
  );

  return (
    <>
      <div className="min-h-screen bg-gray-50 font-sans text-gray-900 selection:bg-green-100 selection:text-green-900 overflow-x-hidden relative">
        <header className="bg-white shadow-sm border-b-4 border-green-600 sticky top-0 z-20">
          <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2 md:gap-3">
              <div className="flex-shrink-0">
                <MiniLogoIFMG />
              </div>
              <div className="leading-tight">
                <div className="font-black text-gray-800 text-lg md:text-xl tracking-tight">
                  PESQUISA DE ACOMPANHAMENTO DE EGRESSOS
                </div>
                <div className="text-[10px] md:text-xs text-gray-500 font-medium mt-0.5"></div>
              </div>
            </div>
            {!isSubmitted && step > 0 && (
              <span className="text-[10px] md:text-xs font-bold text-green-700 px-2 md:px-3 py-1 bg-green-50 rounded-full border border-green-200 flex-shrink-0">
                Etapa {step}/5
              </span>
            )}
          </div>
        </header>

        <main className="max-w-2xl mx-auto px-3 sm:px-4 py-6 md:py-8 w-full">
          {isSubmitted ? (
            renderSuccess()
          ) : step === 0 ? (
            renderWelcome()
          ) : (
            <div className="bg-white rounded-2xl shadow-xl p-4 sm:p-6 md:p-8 border border-gray-100 min-h-[500px] flex flex-col relative transition-all duration-300">
              <ProgressBar currentStep={step - 1} totalSteps={5} />

              <div className="flex-grow">
                {step === 1 && renderStep1_Personal()}
                {step === 2 && renderStep2_Academic()}
                {step === 3 && renderStep3_Evaluation()}
                {step === 4 && renderStep4_Career()}
                {step === 5 && renderStep5_Connection()}
              </div>

              <div className="flex justify-between items-center mt-8 md:mt-10 pt-5 md:pt-6 border-t border-gray-100">
                <button
                  onClick={handleBack}
                  disabled={isSaving}
                  className="text-gray-500 hover:text-green-600 font-medium px-3 md:px-4 py-2 rounded-lg hover:bg-gray-50 transition flex items-center gap-1 focus:outline-none disabled:opacity-50 text-sm md:text-base"
                >
                  <ChevronLeft size={18} />{" "}
                  <span className="hidden sm:inline">Voltar</span>
                </button>

                <button
                  onClick={handleNext}
                  disabled={isSaving}
                  className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 md:px-8 rounded-full shadow-lg transform transition hover:-translate-y-1 flex items-center gap-2 focus:ring-4 focus:ring-green-200 outline-none disabled:opacity-70 disabled:cursor-not-allowed text-sm md:text-base"
                >
                  {isSaving ? (
                    <>
                      <Loader2 className="animate-spin" size={18} /> Salvando...
                    </>
                  ) : (
                    <>
                      {step === 5 ? "Enviar" : "Continuar"}{" "}
                      {step === 5 ? (
                        <Send size={16} />
                      ) : (
                        <ChevronRight size={16} />
                      )}
                    </>
                  )}
                </button>
              </div>
            </div>
          )}
        </main>

        {!isSubmitted && (
          <footer className="text-center py-6 md:py-8 text-gray-400 text-xs md:text-sm border-t border-gray-200 mt-4 md:mt-8 bg-white px-4">
            <p>© 2026 Instituto Federal de Minas Gerais</p>
          </footer>
        )}
      </div>

      {showPrintModal && (
        <div className="fixed inset-0 z-50 bg-black/95 flex flex-col items-center justify-center p-4 animate-fade-in overflow-y-auto">
          <div className="w-full max-w-sm flex flex-col items-center">
            <div className="text-center mb-6 mt-10">
              <div className="inline-flex bg-green-500 text-white p-3 rounded-full mb-3 animate-bounce">
                <Camera size={32} />
              </div>
              <h3 className="text-white font-bold text-2xl mb-2">
                Hora do Print!
              </h3>
              <p className="text-gray-300 text-sm px-4">
                O link e a legenda já estão copiados no seu teclado.
                <br />
                Faça uma captura desta tela agora e cole no seu Story.
              </p>
            </div>

            <div className="transform scale-110 mb-8 pointer-events-none w-full flex justify-center">
              <IfmgBadge />
            </div>

            <button
              onClick={() => setShowPrintModal(false)}
              className="mt-4 bg-white hover:bg-gray-200 text-black px-8 py-4 rounded-full font-bold text-lg shadow-lg transition-transform hover:scale-105 mb-10 w-full"
            >
              Pronto, já tirei o print!
            </button>
          </div>
        </div>
      )}
    </>
  );
}
